import { render, staticRenderFns } from "./EditingLimit.vue?vue&type=template&id=baebf78c&scoped=true"
import script from "./EditingLimit.vue?vue&type=script&lang=js"
export * from "./EditingLimit.vue?vue&type=script&lang=js"
import style0 from "./EditingLimit.vue?vue&type=style&index=0&id=baebf78c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baebf78c",
  null
  
)

export default component.exports